import { StoreFinderButton as StoreFinderButtonBase } from "@omni/components/components/Navigation/Buttons/StoreFinderButton/storeFinderButton";
import { StoreFinderButtonProps } from "@omni/types/components/props/storeFinderButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { StoreFinderButtonComponent } from "@/components/Navigation/Buttons/StoreFinderButton/storeFinderButton.component";

export const StoreFinderButton = ({
    // HeaderButton props
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover
}: StoreFinderButtonProps<BaseStore.Etna>) => {
    return (
        <StoreFinderButtonBase
            text={text}
            ariaLabel={ariaLabel}
            hiddenText={hiddenText}
            icon={icon}
            link={link}
            invert={invert}
            invertMobile={invertMobile}
            showMenuOnHover={showMenuOnHover}
        >
            <StoreFinderButtonComponent />
        </StoreFinderButtonBase>
    );
};
